module.exports = __webpack_public_path__ + "img/sign-up-with-google.b5b00c8d.png";